import jQuery from 'jquery';
import 'slick-carousel';

jQuery('.main-diagnostics-slider').slick({
  fade: true,
  dots: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        adaptiveHeight: true
      }
    }
  ]
});